import { render, staticRenderFns } from "./VehicleInsurance.vue?vue&type=template&id=318cf0e0&"
import script from "./VehicleInsurance.vue?vue&type=script&lang=js&"
export * from "./VehicleInsurance.vue?vue&type=script&lang=js&"
import style0 from "./VehicleInsurance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports